import React from 'react';
import { Card, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import { DesktopOutlined, TeamOutlined } from '@ant-design/icons';

const HomePage = () => {
  const navigate = useNavigate();

  const cardStyle1 = {
    height: '250px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1890ff',
    color: '#fff',
    fontSize: '24px',
    borderRadius: '16px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
    cursor: 'pointer',
    transition: 'transform 0.3s',
  };

  const cardStyle2 = {
    height: '250px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#52c41a',
    color: '#fff',
    fontSize: '24px',
    borderRadius: '16px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
    cursor: 'pointer',
    transition: 'transform 0.3s',
  };

  const iconStyle = {
    fontSize: '50px',
    marginBottom: '20px',
  };

  const backgroundStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1890ff, #a0f2a0)', // bleu vers vert clair
  };

  return (
    <div style={backgroundStyle}>
      <style>{`
        .card:hover {
          transform: scale(1.05);
        }
      `}</style>
      <div style={{ padding: '50px', width: '100%' }}>
        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} sm={12} md={10}>
            <Card
              hoverable
              className="card"
              style={cardStyle1}
              onClick={() => navigate('/declarations_pb_cap')}
            >
              Déclaration de problèmes de connexion — CAP
            </Card>
          </Col>
          <Col xs={24} sm={12} md={10}>
            <Card
              hoverable
              className="card"
              style={cardStyle2}
              onClick={() => navigate('/declarations_pb_keolis')}
            >
              Déclaration de problèmes de connexion — KEOLIS
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HomePage;
